/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ExternalProjectLinksControllerUpsertMutationRequest, ExternalProjectLinksControllerUpsertMutationResponse, ExternalProjectLinksControllerUpsert400, ExternalProjectLinksControllerUpsert401, ExternalProjectLinksControllerUpsert403, ExternalProjectLinksControllerUpsert404 } from "../../models/externalProjectLinksController/ExternalProjectLinksControllerUpsert";

function getExternalProjectLinksControllerUpsertUrl() {
  const res = { method: 'PUT', url: `/api/v1/external-project-links` as const }  
  return res
}

/**
 * @summary Link or re-link a Procore project to a DC project (upsert)
 * {@link /api/v1/external-project-links}
 */
export async function externalProjectLinksControllerUpsert(data?: ExternalProjectLinksControllerUpsertMutationRequest, config: Partial<RequestConfig<ExternalProjectLinksControllerUpsertMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ExternalProjectLinksControllerUpsertMutationResponse, ResponseErrorConfig<ExternalProjectLinksControllerUpsert400 | ExternalProjectLinksControllerUpsert401 | ExternalProjectLinksControllerUpsert403 | ExternalProjectLinksControllerUpsert404>, ExternalProjectLinksControllerUpsertMutationRequest>({ method : "PUT", url : getExternalProjectLinksControllerUpsertUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}